// test4
(4 && 0);
